import { useRef } from 'react';
import emailjs from '@emailjs/browser';

function Admissions() {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    emailjs.sendForm(
      'YOUR_SERVICE_ID',
      'YOUR_TEMPLATE_ID',
      form.current,
      'YOUR_PUBLIC_KEY'
    ).then(() => {
      alert('Application submitted successfully! ✅ We will contact you soon.');
      form.current.reset();
    }).catch(() => {
      alert('Something went wrong. Please try again.');
    });
  };

  const inputStyle = {
    width: '100%',
    padding: '12px',
    marginBottom: '16px',
    border: '1px solid #ccc',
    borderRadius: '6px',
    fontSize: '15px'
  };

  return (
    <div style={{ padding: '60px 40px', maxWidth: '800px', margin: '0 auto' }}>
      <h1 style={{ color: '#1a6b3c', fontSize: '36px', marginBottom: '10px' }}>Admissions</h1>
      <p style={{ color: '#555', fontSize: '18px', marginBottom: '40px' }}>
        Fill in the details below to apply for admission at Srilakshmi Matric High School.
      </p>

      <div style={{ background: 'white', borderRadius: '12px', padding: '40px', boxShadow: '0 4px 15px rgba(0,0,0,0.08)' }}>
        <form ref={form} onSubmit={sendEmail}>

          {/* Student Details */}
          <h2 style={{ color: '#1a6b3c', marginBottom: '20px', fontSize: '20px' }}>🎓 Student Details</h2>

          <label style={{ fontWeight: 'bold', color: '#444' }}>Student Name</label>
          <input name="student_name" placeholder="Enter student full name" required style={inputStyle} />

          <div style={{ display: 'flex', gap: '16px' }}>
            <div style={{ flex: 1 }}>
              <label style={{ fontWeight: 'bold', color: '#444' }}>Age</label>
              <input name="student_age" placeholder="Age" type="number" required style={inputStyle} />
            </div>
            <div style={{ flex: 1 }}>
              <label style={{ fontWeight: 'bold', color: '#444' }}>Date of Birth</label>
              <input name="student_dob" type="date" required style={inputStyle} />
            </div>
          </div>

          <label style={{ fontWeight: 'bold', color: '#444' }}>Class Applying For</label>
          <select name="student_class" required style={inputStyle}>
            <option value="">Select Class</option>
            <option value="Pre KG">Pre KG</option>
<option value="LKG">LKG</option>
<option value="UKG">UKG</option>
{[1,2,3,4,5,6,7,8,9,10,11,12].map(c => (
  <option key={c} value={`Class ${c}`}>Class {c}</option>
))}
          </select>

          {/* Parent Details */}
          <h2 style={{ color: '#1a6b3c', margin: '20px 0', fontSize: '20px' }}>👨‍👩‍👧 Parent Details</h2>

          <label style={{ fontWeight: 'bold', color: '#444' }}>Parent Name</label>
          <input name="parent_name" placeholder="Enter parent full name" required style={inputStyle} />

          <label style={{ fontWeight: 'bold', color: '#444' }}>Phone Number</label>
          <input name="parent_phone" placeholder="Enter phone number" type="tel" required style={inputStyle} />

          <label style={{ fontWeight: 'bold', color: '#444' }}>Address</label>
          <textarea name="student_address" placeholder="Enter full address" rows={3} required style={inputStyle} />

          <button type="submit" style={{
            background: 'linear-gradient(135deg, #1a6b3c, #1565c0)',
            color: 'white',
            padding: '14px 40px',
            border: 'none',
            borderRadius: '6px',
            fontSize: '16px',
            cursor: 'pointer',
            width: '100%',
            fontWeight: 'bold'
          }}>
            Submit Application 🎓
          </button>

        </form>
      </div>
    </div>
  );
}

export default Admissions;